class LazyVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.video) return

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)
  }

  setupListeners () {
    super.setupListeners()

    if (!this.video) return

    if (this.video.hasAttribute('autoplay')) {
      this.listeners.add(this.video, 'playing', () =>
        this.toggleAttribute('loaded', true),
      )
    } else {
      this.listeners.add(this.video, 'canplay', () =>
        this.toggleAttribute('loaded', true),
      )
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.loadVideo(observer)
  }

  loadVideo (observer) {
    if (this.video.hasAttribute('data-poster')) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    window.BAO.utils
      .getElements('source[data-src]', {
        context: this.video,
      })
      ?.forEach(sourceEl => {
        sourceEl.src = sourceEl.dataset.src
        this.video.load()
      })

    observer.unobserve(this.video)

    if (
      window.BAO.utils.viewportSize() !== 'xs' ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }

  get video () {
    return window.BAO.utils.getElement('video', { context: this })
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
